
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import * as _ref_QHN0YWJsZWxpYi9ibGFrZTJi_ from '@stablelib/blake2b';
import * as _ref_QHN0YWJsZWxpYi9lZDI1NTE5_ from '@stablelib/ed25519';
import * as _ref_QHN0YWJsZWxpYi9obWFj_ from '@stablelib/hmac';
import * as _ref_QHN0YWJsZWxpYi9zaGEyNTY_ from '@stablelib/sha256';
import * as _ref_QHN0YWJsZWxpYi9zaGE1MTI_ from '@stablelib/sha512';
import { instantiate } from './attoWallet.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_,
    '@stablelib/blake2b': _ref_QHN0YWJsZWxpYi9ibGFrZTJi_,
    '@stablelib/ed25519': _ref_QHN0YWJsZWxpYi9lZDI1NTE5_,
    '@stablelib/hmac': _ref_QHN0YWJsZWxpYi9obWFj_,
    '@stablelib/sha256': _ref_QHN0YWJsZWxpYi9zaGEyNTY_,
    '@stablelib/sha512': _ref_QHN0YWJsZWxpYi9zaGE1MTI_
})).exports;

export const {
memory,
_initialize
} = exports


